import React from "react";

/**
 * Plain text / template body. Preserves newlines, wraps long words.
 */
const TextMessage = ({ message }) => (
  <span className="wa-msg__text">{message.content}</span>
);

export default TextMessage;
